<p>submission-detail-mixin works!</p>
